import { initializeMixpanel } from 'lib/trackEvent'

const initialize = () => {
  initializeMixpanel()
}

export default initialize
